import { schema } from "normalizr";

const user = new schema.Entity("users");
const arrayOfUsers = [user];

export { user, arrayOfUsers };
